import reducers from './reducers';
import watchGlobalChanges from './watcher';

watchGlobalChanges();

export { default as globalOperations } from './operations';

export default reducers;
